import React from 'react';

import '../styles/Footer.css';

function Footer(props) {
  return (
    <div className="hide-on-mobile footer">
      <p>&copy; 2017 Hippo Education Inc. - All rights reserved.</p>
      <div>
        <a href="https://www.hippoed.com/em/about">About</a>
        <a href="https://www.hippoed.com/em/news">News</a>
        <a href="https://www.hippoed.com/em/help">Help</a>
        <a href="https://www.hippoed.com/em/contact">Contact</a>
        <a href="https://www.hippoed.com/em/privacy">Privacy & Security Policy</a>
        <a href="https://www.hippoed.com/em/terms">Terms of Use</a>
      </div>
    </div>
  );
}

export default Footer;

// QuestionCountProgress.propTypes = {
//   completed: React.PropTypes.bool.isRequired,
// };



// WEBPACK FOOTER //
// ./src/components/Footer.js